import React, { memo } from 'react';
import ContentBox from 'xpi-black-ui/Base/ContentBox';
import { Row } from 'xpi-black-ui/Base/Grid';
import { Text } from 'xpi-black-ui/Base/Typography';
import Icon from 'xpi-black-ui/Base/Icon';
import GenericOrderBy from '../GenericOrderBy';
import GenericPagination from '../GenericPagination';
import WrapperMain, { WrapperContentBoxFooter, WrapperContentBoxChildren, WrapperFooter, WrapperHeader, WrapperHeaderUpdate } from './styles';

function GenericTableBox({ onUpdate, title, orderBy, pagination, children }) {
  return (
    <WrapperMain>
      <ContentBox>
        <Row justifyContent="space-between" align="baseline">
          <Text bigger>{title}</Text>

          <WrapperHeader>
            {orderBy && <GenericOrderBy
              onChange={orderBy.onChange}
              title={orderBy.title}
              initialOptions={orderBy.initialOptions}
              options={orderBy.options}
            />}

            <WrapperHeaderUpdate onClick={onUpdate}>
              <Icon type="update" title="Atualizar" />
            </WrapperHeaderUpdate>
          </WrapperHeader>
        </Row>
      </ContentBox>

      <WrapperContentBoxChildren>
        {children}
      </WrapperContentBoxChildren>

      {pagination && (
        <WrapperContentBoxFooter>
          <Row justifyContent="space-between" align="baseline">
            <WrapperFooter>
              <GenericPagination
                onPageChange={pagination.onPageChange}
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
              />
            </WrapperFooter>
          </Row>
        </WrapperContentBoxFooter>
      )}
    </WrapperMain>
  );
}

export default memo(GenericTableBox);
